import Vue from 'vue';
import Router from 'vue-router';

// 应用路由组件
Vue.use(Router);

// 登录
import Logout from '@/views/Logout/Logout.vue';

// 布局页
import Main from '@/views/Main/Main.vue';
import HomeLay from '@/views/HomeLay/HomeLay.vue';
import IndexHome from '@/views/IndexHome/IndexHome.vue';
import MeLayout from '@/views/Me/LayOutTH/LayOutTH.vue';
import Close from '@/views/Layout/Close.vue';
import ControlPanel from '@/views/Me/ControlPanel/ControlPanel.vue';//控制面板
import UserInfo from '@/views/Me/UserInfo/UserInfo.vue';//g恶人
import Agent from '@/views/Me/Agent/Agent.vue';//代理商管理
import MemberCenter from '@/views/Me/MemberCenter/MemberCenter.vue';//代理商管理
import MemberUp from '@/views/Me/MemberUp/MemberUp.vue';//代理商管理
import CaseManagement from '@/views/Me/CaseManagement/CaseManagement.vue';//代理商管理
import ContractManagement from '@/views/Me/ContractManagement/ContractManagement.vue';//代理商管理
import CommissionManagement from '@/views/Me/CommissionManagement/CommissionManagement.vue';//代理商管理
import CashRequest from '@/views/Me/CashRequest/CashRequest.vue';//提现申请
import LawList from '@/views/Me/LawList/LawList.vue';//提现申请
import PromotionManagement from '@/views/Me/PromotionManagement/PromotionManagement.vue';//代理商管理
import SubAccountManagement from '@/views/Me/SubAccountManagement/SubAccountManagement.vue';//代理商管理
import MessageBoard from '@/views/Me/MessageBoard/MessageBoard.vue';//留言板
import Invoice from '@/views/Me/Invoice/Invoice.vue';//留言板
//注册
import RegisterTH from '@/views/RegisterTH/RegisterTH.vue';
import LoginTH from '@/views/LoginTH/LoginTH.vue';
import Notice from '@/views/Notice/Notice.vue';
import Message from '@/views/Message/Message.vue';
import NoticeList from '@/views/NoticeList/NoticeList.vue';



// 充值

import Password from '@/views/Password/Password.vue';
// 企业认证
//Todo


var router = new Router({
  mode: 'history',
  routes: [
    { name: 'Logout', path: '/Logout', component: Logout },

    { name: 'RegisterTH', path: '/RegisterTH', component: RegisterTH },
    { name: 'LoginTH', path: '/LoginTH', component: LoginTH },
    {
      path: '/',
      component: HomeLay,
      redirect: '/IndexHome',
      children: [
        { name: 'IndexHome', path: 'IndexHome', component: IndexHome, meta: { name: '首页', } },
        { name: 'NoticeList', path: '/NoticeList', component: NoticeList },
        { name: 'Notice', path: '/Notice', component: Notice },
        { name: 'Message', path: '/Message', component: Message },
      ],
      meta: { name: '首页' }
    },
    {
      path: "/My",
      redirect: '/',
      component: MeLayout,
      children: [
        { name: 'UserInfo', path: 'UserInfo', component: UserInfo, meta: { name: '个人中心', isMe: true  } },
        { name: 'ControlPanel', path: 'ControlPanel', component: ControlPanel, meta: { name: '控制面板', isMe: true  } },
        { name: 'Agent', path: 'Agent', component: Agent, meta: { name: '代理管理', isMe: true  } },
        { name: 'MemberCenter', path: 'MemberCenter', component: MemberCenter, meta: { name: '会员认证', isMe: true  } },
        { name: 'MemberUp', path: 'MemberUp', component: MemberUp, meta: { name: '会员认证', isMe: true  } },
        { name: 'CaseManagement', path: 'CaseManagement', component: CaseManagement, meta: { name: '案件管理', isMe: true  } },
        { name: 'ContractManagement', path: 'ContractManagement', component: ContractManagement, meta: { name: '合同管理', isMe: true  } },
        { name: 'CommissionManagement', path: 'CommissionManagement', component: CommissionManagement, meta: { name: '佣金管理', isMe: true  } },
        { name: 'CashRequest', path: 'CashRequest', component: CashRequest, meta: { name: '提现申请', isMe: true  } },
        { name: 'LawList', path: 'LawList', component: LawList, meta: { name: '法律文书', isMe: true  } },
        { name: 'PromotionManagement', path: 'PromotionManagement', component: PromotionManagement, meta: { name: '推广管理', isMe: true  } },
        { name: 'SubAccountManagement', path: 'SubAccountManagement', component: SubAccountManagement, meta: { name: '子账号管理', isMe: true  } },
        { name: 'MessageBoard', path: 'MessageBoard', component: MessageBoard, meta: { name: '留言板', isMe: true  } },
        { name: 'Invoice', path: 'Invoice', component: Invoice, meta: { name: '我的发票', isMe: true  } },
      ],
      meta: { name: '我' }
    },
    {
      path: "/Forgot",
      redirect: '/',
      component: Main,
      children: [
        { name: 'Password', path: 'Password', component: Password, meta: { name: '找回密码', isLogin: true } },
      ],
      meta: { name: '找回' }
    },
    {
      name: 'Close',
      path: "/Close",
      component: Close
    }
  ]
});
// beforeEach 全局钩子
router.beforeEach(function (to, from, next) {
  var expires = localStorage.ms_token_expires;
  var now = (new Date()).getTime();
  next();
});

// 定义路由
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js